import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output
} from '@angular/core';
import { Consent } from '@models/models';
import { ConsentMethods } from './consent-list.model';

@Component({
	selector: '',
	template: ''
})
export class ConsentListComponent implements OnChanges {
	@Input() consents: Array<Consent>;
	@Output() deleted: EventEmitter<any> = new EventEmitter();

	constructor() {}

	ngOnChanges() {
		if (this.consents !== null && typeof this.consents !== 'undefined') {
			this.consents = this.formatOptInMethod(this.consents);
		}
	}

	public deleteConsent(event: any, consentId: number): void {
		event.stopImmediatePropagation();
		this.deleted.emit(consentId);
	}

	private formatOptInMethod(consents: Array<Consent>): Array<Consent> {
		return consents.map(consent => {
			switch (consent.method) {
				case ConsentMethods.BY_USER:
					consent.methodToShow = 'Added by me';
					return consent;
				case ConsentMethods.BY_CONTACT_FORM:
					consent.methodToShow = 'Added by Client via Contact Form';
					return consent;
				case ConsentMethods.BY_CONTRACT:
					consent.methodToShow = 'Added by Client via Contract';
					return consent;
				case ConsentMethods.BY_QUESTIONNAIRE:
					consent.methodToShow = 'Added by Client via Questionnaire';
					return consent;
				default:
					return consent;
			}
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/base/client/consent-list/consent-list.ts